import React, { useEffect } from 'react';
import { is, head } from 'ramda';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import QuizQuestionPresenter from 'presenters/QuizQuestionPresenter';
import QuizPresenter from 'presenters/QuizPresenter';
import InputWithSlider from 'sharedComponents/InputWithSlider';

import useStyles from './useStyles';

const MAX_RATIO = 1.1;

const MortgageBalanceQuestion = props => {
  const { t } = useTranslation();
  const { question, onChange, values, setValidity } = props;
  const classes = useStyles();

  const mortgageBalanceField = head(QuizQuestionPresenter.quizFields(question));
  const currentHouseValue = QuizPresenter.currentHouseValue(values);
  const currentValue = QuizPresenter[mortgageBalanceField](values);

  const totalDisplay = QuizPresenter.readableTotalDisplay(values);
  const agentCommision = QuizPresenter.readableAgentCommision(values);
  const adjustedEquity = QuizPresenter.readableAdjustedEquity(values);

  useEffect(() => {
    const defaultMortgageBalanceValue = QuizPresenter.calculateDefaultMortgageBalance(values);
    onChange({ field: mortgageBalanceField, value: defaultMortgageBalanceValue });
  }, []);

  useEffect(() => {
    const isValid = is(Number, currentValue);

    setValidity(isValid);
  }, [currentValue]);

  const options = QuizQuestionPresenter.options(question);
  const { min, strictLimit } = options;
  const max = Math.round((currentHouseValue * MAX_RATIO) / 1000) * 1000;

  const handleValueChange = value => {
    onChange({ field: mortgageBalanceField, value });
  };

  return (
    <Box>
      <Typography variant="h1">{QuizQuestionPresenter.label(question)}</Typography>
      <Box mt={2} />
      <Box>
        <InputWithSlider
          className={classes.input}
          value={currentValue}
          min={min}
          max={max}
          marksDivider={1000}
          onChange={handleValueChange}
          strictLimit={strictLimit}
        />
      </Box>
      <Box className={classes.calculationsBar}>
        <Box className={classes.calculationsItem}>
          <Typography variant="body1" color="secondary">
            {t('components.Quiz.MortgageBalanceQuestion.equity')}
          </Typography>
          <Typography variant="h1">{totalDisplay}</Typography>
        </Box>
        <Box className={classes.calculationsItem}>
          <Typography variant="body1" color="secondary">
            {t('components.Quiz.MortgageBalanceQuestion.agentFees')}
          </Typography>
          <Typography variant="h1">{agentCommision}</Typography>
        </Box>
        <Box className={classes.calculationsItem}>
          <Typography variant="body1" color="secondary">
            {t('components.Quiz.MortgageBalanceQuestion.adjusted')}
          </Typography>
          <Typography variant="h1">{adjustedEquity}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

MortgageBalanceQuestion.propTypes = {
  question: QuizQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  setValidity: PropTypes.func.isRequired,
  values: QuizPresenter.shape().isRequired,
};

export default MortgageBalanceQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/MortgageBalanceQuestion/MortgageBalanceQuestion.js